import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  inject,
  input,
  Input,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslationService } from '../../../../core/services/translate/translation.service';
import { TextInputConfigI } from '../text-input/interfaces/text-input-config.interface';
import { ValidationHintComponent } from '../validation-hint/validation-hint.component';

@Component({
  selector: 'app-search-input',
  imports: [ValidationHintComponent, ReactiveFormsModule],
  templateUrl: './search-input.component.html',
  styleUrl: './search-input.component.scss',
})
export class SearchInputComponent implements OnInit, AfterViewChecked {
  private readonly renderer = inject(Renderer2);
  private readonly translationService = inject(TranslationService);
  private readonly cd = inject(ChangeDetectorRef);

  @ViewChild('input') input!: ElementRef<HTMLInputElement>;

  config = input.required<TextInputConfigI>();
  isFocused = false;

  @Input({ required: true })
  textControl!: FormControl<string | null>;

  ngAfterViewChecked(): void {
    this.cd.detectChanges();
  }

  lang = this.translationService.language();

  ngOnInit(): void {
    this.focusListener();
  }

  focusListener() {
    this.renderer.listen('window', 'click', (event: PointerEvent) => {
      if (!this.input) {
        this.isFocused = false;
        return;
      }
      if (event.target === this.input.nativeElement) this.isFocused = true;
      else this.isFocused = false;
    });
  }
}
